/* global generalCommittedRevenuesIndexUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import GeneralRevenuesTable from './GeneralRevenuesTable';

function RevenueCommitmentIndex() {
    return <GeneralRevenuesTable fetchUrl={generalCommittedRevenuesIndexUrl} />;
}

if (document.getElementById('revenueCommitmentIndex')) {
    var root = document.getElementById('revenueCommitmentIndex');
    ReactDOM.render(
        <App>
            <RevenueCommitmentIndex />
        </App>,
        root,
    );
}
